import { render } from "./TagUpdate.vue?vue&type=template&id=1f577174"
import script from "./TagUpdate.vue?vue&type=script&lang=js"
export * from "./TagUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/roshdfarms-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__